export default () => {
  const data = {
    event_name: 'click',
    button_name: 'talk_with',
    page_section: 'card_real_estate',
    name_of_the_page_viewed: 'home_personal',
  };
  return data;
};
